module.exports = __webpack_public_path__ + "static/media/arrow.70c717aa.svg";